/* ÜRETİLMİŞ DOSYA — ELLE DÜZENLEMEYİN.
   Kaynak: ris-api/RIS.UI/src/shared/template-builder
   Güncelleme: ris-api/scripts/sync-template-builder.sh */

import { Tooltip } from 'antd'
import { BoldOutlined, ItalicOutlined, UnderlineOutlined, ClearOutlined } from '@ant-design/icons'
import { useEffect, useRef, useState } from 'react'

/**
 * Tablo hücresi için hafif zengin metin alanı.
 *
 * Neden TinyMCE değil: 22×3'lük bir soru tablosunda 66 editör örneği açmak ağır. Hücre içeriği
 * `contentEditable` ile düzenlenir; araç çubuğu yalnız odaklanınca çıkar.
 *
 * Ürettiği HTML alt kümesi motorun (TableWriter → HtmlToOpenXml) çevirebildiğiyle aynıdır:
 * &lt;b&gt;, &lt;i&gt;, &lt;u&gt;, &lt;span style="color:..."&gt;, &lt;br&gt;.
 *
 * DİKKAT: contentEditable React tarafından kontrol edilirse imleç başa atlar. Bu yüzden innerHTML
 * yalnızca alan odakta DEĞİLKEN dışarıdan güncellenir.
 */

const COLORS = [
    { value: '', label: 'Varsayılan', swatch: '#262626' },
    { value: '#c00000', label: 'Kırmızı', swatch: '#c00000' },
    { value: '#0070c0', label: 'Mavi', swatch: '#0070c0' },
    { value: '#00854a', label: 'Yeşil', swatch: '#00854a' },
    { value: '#7030a0', label: 'Mor', swatch: '#7030a0' },
    { value: '#808080', label: 'Gri', swatch: '#808080' },
]

export default function RichCell({ value, onChange, placeholder, t = (x) => x }) {
    const ref = useRef(null)
    const [focused, setFocused] = useState(false)

    useEffect(() => {
        const node = ref.current
        if (!node || focused) return
        const next = value || ''
        if (node.innerHTML !== next) node.innerHTML = next
    }, [value, focused])

    const exec = (command, arg) => {
        // Renk için CSS üret (font etiketi yerine span style) — motorun beklediği biçim bu.
        document.execCommand('styleWithCSS', false, true)
        document.execCommand(command, false, arg)
        if (ref.current) onChange(ref.current.innerHTML)
    }

    const button = (title, icon, onMouseDown) => (
        <Tooltip title={title}>
            <span
                className="tb-cell-tool"
                role="button"
                tabIndex={-1}
                // mousedown + preventDefault: tıklarken seçim kaybolmasın.
                onMouseDown={(e) => { e.preventDefault(); onMouseDown() }}
            >
                {icon}
            </span>
        </Tooltip>
    )

    return (
        <div className={`tb-cell${focused ? ' tb-cell-focused' : ''}`}>
            {focused && (
                <div className="tb-cell-toolbar" onMouseDown={(e) => e.preventDefault()}>
                    {button(t('Kalın'), <BoldOutlined />, () => exec('bold'))}
                    {button(t('İtalik'), <ItalicOutlined />, () => exec('italic'))}
                    {button(t('Altı çizili'), <UnderlineOutlined />, () => exec('underline'))}
                    <span className="tb-cell-sep" />
                    {COLORS.map((color) => (
                        <Tooltip key={color.value || 'default'} title={t(color.label)}>
                            <span
                                className="tb-cell-swatch"
                                style={{ background: color.swatch }}
                                role="button"
                                tabIndex={-1}
                                onMouseDown={(e) => {
                                    e.preventDefault()
                                    exec('foreColor', color.value || '#262626')
                                }}
                            />
                        </Tooltip>
                    ))}
                    <span className="tb-cell-sep" />
                    {button(t('Biçimi temizle'), <ClearOutlined />, () => exec('removeFormat'))}
                </div>
            )}

            <div
                ref={ref}
                className="tb-cell-input"
                contentEditable
                suppressContentEditableWarning
                data-placeholder={placeholder || ''}
                onFocus={() => setFocused(true)}
                onBlur={() => {
                    setFocused(false)
                    if (ref.current) onChange(ref.current.innerHTML)
                }}
                onInput={() => { if (ref.current) onChange(ref.current.innerHTML) }}
            />
        </div>
    )
}